import { env } from "@/env";

/**
 * This token is used to authenticate requests to the GraphlQL API and the Redis revalidation app
 */
export const createServiceAuthToken = () =>
  `Basic ${btoa(
    `${env.NEXT_PUBLIC_SERVICE_USER}:${process.env.NEXT_PUBLIC_SERVICE_SECRET}`,
  )}`;
